if (!customElements.get('video-reviews')) {
  customElements.define('video-reviews', class VideoReviews extends HTMLElement {
    connectedCallback() {
      this.pagination = this.closest('.section__video-slider')?.querySelector('.swiper-pagination');

      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      if (typeof Swiper === 'undefined') return;
      if (this.swiper) return;

      this.swiper = new Swiper(this, {
        slidesPerView: 1.2,
        spaceBetween: 25,
        watchOverflow: true,
        loop: true,
        pagination: {
          el: this.pagination,
          clickable: true,
        },

        breakpoints: {
          480: {
            slidesPerView: 2.7,
            spaceBetween: 32,
          },
          851: {
            slidesPerView: 3.7,
            spaceBetween: 43,
          },
          1441: { slidesPerView: 4.7 },
          1921: { slidesPerView: 5.7 }
        },
      });
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  });
}
